"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var dynamic_1 = __importDefault(require("next/dynamic"));
// FIXME It looks like typings for next/error are wrong
var ErrorPage = dynamic_1["default"](function () { return Promise.resolve().then(function () { return __importStar(require('next/error')); }); });
/**
 * Small helper to generate errors object if needed
 */
exports.generatePageError = function (statusCode, params) {
    return {
        error: __assign({ statusCode: statusCode }, (params || {}))
    };
};
/**
 * This higher-order component is used to render the Error page if a HTTP status
 * code >400 is thrown by one of the pages.
 *
 * To trigger it, just add statusCode to the object returned by getInitialProps
 *
 * This solution is based on Tim Neutkens's insights and inspired by Nuxt.js
 * https://spectrum.chat/next-js/general/error-handling-in-async-getinitialprops~99400c6c-0da8-4de5-aecd-2ecf122e8ad0
 * https://github.com/nuxt/nuxt.js/issues/895#issuecomment-308682972
 */
var withErrorHoC = function (CustomErrorComponent) {
    var ErrorComponent = (CustomErrorComponent !== null && CustomErrorComponent !== void 0 ? CustomErrorComponent : ErrorPage);
    // First function returned, the one allowing to pass the App component as a parameter
    return function (AppComponent) {
        var _this = this;
        var _a;
        // The actualy component working as a wrapper around _app
        return _a = /** @class */ (function (_super) {
                __extends(WithError, _super);
                function WithError() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                WithError.prototype.render = function () {
                    var pageProps = this.props.pageProps;
                    var error = pageProps.error;
                    if (error && error.statusCode >= 400) {
                        var error_1 = pageProps.error, otherPageProps = __rest(pageProps, ["error"]);
                        var errorPageProps = __assign(__assign({}, otherPageProps), error_1);
                        return (react_1["default"].createElement(AppComponent, __assign({}, this.props, { Component: ErrorComponent, pageProps: errorPageProps })));
                    }
                    return react_1["default"].createElement(AppComponent, __assign({}, this.props));
                };
                return WithError;
            }(react_1["default"].Component)),
            _a.getInitialProps = function (appContext) { return __awaiter(_this, void 0, void 0, function () {
                var appProps, res, pageProps, errorInitialProps;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            appProps = {
                                pageProps: {}
                            };
                            if (!AppComponent.getInitialProps) return [3 /*break*/, 2];
                            return [4 /*yield*/, AppComponent.getInitialProps(appContext)];
                        case 1:
                            appProps = _a.sent();
                            if (typeof appProps.pageProps === 'undefined') {
                                console.error('If you have a getInitialProps method in your custom _app.js file, you must explicitly return pageProps. For more information, see: https://github.com/zeit/next.js#custom-app');
                            }
                            _a.label = 2;
                        case 2:
                            res = appContext.ctx.res;
                            pageProps = appProps.pageProps;
                            if (!('error' in pageProps && res)) return [3 /*break*/, 5];
                            if (!('statusCode' in pageProps.error))
                                throw new Error('The error object should have a "statusCode" property');
                            if (typeof pageProps.error.statusCode !== 'number')
                                throw new Error('The "statusCode" property should be a number.');
                            errorInitialProps = {};
                            if (!ErrorComponent.getInitialProps) return [3 /*break*/, 4];
                            return [4 /*yield*/, ErrorComponent.getInitialProps(appContext.ctx)];
                        case 3:
                            errorInitialProps = _a.sent();
                            appProps.pageProps = __assign(__assign({}, errorInitialProps), appProps.pageProps);
                            _a.label = 4;
                        case 4:
                            res.statusCode = pageProps.error.statusCode;
                            _a.label = 5;
                        case 5: return [2 /*return*/, appProps];
                    }
                });
            }); },
            _a;
    };
};
exports["default"] = withErrorHoC;
//# sourceMappingURL=next-with-error.js.map